import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {ActivateBothLicense} from './activate-both-license'
import {ActivateOneLicense} from './activate-one-license'
import {WaitingLicense} from './waiting-license'

export const TwContainer = tw.div`
  w-[824px]
  h-[439px]
  fixed
  top-1/2
  left-1/2
  translate-x-[-50%]
  translate-y-[-50%]
`

export const NoLicense = () => {
  const [waiting, setWaiting] = useState(false)

  return (
    <div className="w-[100vw] h-[100vh] bg-[#f0f5fe]">
      <TwContainer>
        <ActivateOneLicense waiting={waiting} setWaiting={setWaiting} />

        <ActivateBothLicense waiting={waiting} setWaiting={setWaiting} />

        <WaitingLicense waiting={waiting} />
      </TwContainer>
    </div>
  )
}
